var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tooltip',{staticClass:"item",attrs:{"effect":"light","content":_vm.label,"placement":"bottom","open-delay":200,"disabled":_vm.label == ''}},[_c('el-switch',{on:{"change":_vm.clickItem},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }